import React, { Component } from 'react';
import { Segment, Icon, Popup, Responsive } from 'semantic-ui-react'
import FormatCurrency from "../FormatCurrency"

export default class AccountItem extends Component {

    constructor() {
        super();
        this.state = { paymentLabel: '', amountLabel: '' }
    }

    handleOnUpdate = (e, { width }) => {
        let paymentLabel = 'Payments Remaining';
        let amountLabel = 'Est Amt Remaining';
        if (width <= Responsive.onlyTablet.minWidth) {
            paymentLabel = 'Pmts Remaining'
            amountLabel = 'Est Remaining'
        }
        this.setState({ paymentLabel: paymentLabel, amountLabel: amountLabel });
    }

    render() {
        return (
            <div>
                <Segment attached  >
                    <div className="divLeft14">
                        {this.props.name}
                        {this.props.last_four &&
                            <span> - {this.props.last_four}</span>
                        }
                        <span className="divRight">
                            <FormatCurrency amount={this.props.enrolled_balance} />
                        </span>
                    </div>

                    <Responsive fireOnMount onUpdate={this.handleOnUpdate}></Responsive>
                    {this.props.remaining_payments &&
                        <div className="divItalicLeft12">
                            {this.props.remaining_payments} {this.state.paymentLabel}
                            <span className="divItalicRight12">
                                {this.state.amountLabel}&nbsp;
                            <Popup position='top center' trigger={<Icon fitted name='question circle outline' />} wide>
                                    Amount displayed is an estimate of the remaining amount to be paid toward settlement of the debt including program and delivery fees. For a precise payoff amount, please contact client services.
                            </Popup>:&nbsp;
                            <FormatCurrency amount={this.props.remaining_amount} />
                            </span>
                        </div>
                    }

                    {this.props.original_amount &&
                        <div className="divItalicLeft12">          
                            &nbsp;              
                            <span className="divItalicRight12">
                                Original Balance:&nbsp;                            
                                <FormatCurrency amount={this.props.original_amount} />
                            </span>
                        </div>
                    }

                </Segment>

            </div>

        );
    }
}


// WEBPACK FOOTER //
// ./src/components/AccountItem/index.js